export default "__VITE_ASSET__6a32f637__"